import React from 'react';
import type { FormikProps } from 'formik';
import type { AddCashFundDialogFields } from '@apps/registry/common/components/AddCashFund/types';
import type { DonationFundPlatformTypeEnum } from '@graphql/generated';
import { Flex, Box, TextV2 } from '@withjoy/joykit';
import { useSharedRegistryTranslations } from '@apps/registry/SharedRegistry.i18n';
import type { PaymentMethodOption } from '@shared/utils/paymentMethodOptions';
import { CreditCardToggle } from '../CreditCardToggle/CreditCardToggle';
import { CashOrCheckToggle } from '../CashOrCheckToggle/CashOrCheckToggle';
import { AppPlatformToggle } from '../AppPaymentToggle/AppPlatformToggle';

export interface CashFundPaymentMethodSelectProps {
  formik: FormikProps<AddCashFundDialogFields>;
  isMobile: boolean;
  setPaymentMethod: (paymentMethod?: DonationFundPlatformTypeEnum) => void;
  selectedPaymentMethod: Maybe<PaymentMethodOption>;
  paymentLink: string;
  onUsernameFocus: React.ChangeEventHandler<HTMLInputElement>;
  isEditDialog?: boolean;
  canEnableCreditCard: boolean;
}

export const CashFundPaymentMethodSelect: React.FC<CashFundPaymentMethodSelectProps> = props => {
  const { formik, isEditDialog, canEnableCreditCard } = props;
  const { getCashFundDialogTranslations } = useSharedRegistryTranslations();
  const { paymentSettingsText, errorValidation } = getCashFundDialogTranslations();

  return (
    <Flex
      flexDirection="column"
      alignItems="stretch"
      justifyContent="flex-start"
    >
      <Box paddingBottom={4}>
        <TextV2
          typographyVariant="hed2"
          component="p"
          textAlign={isEditDialog ? 'start' : 'center'}
        >
          {paymentSettingsText}
        </TextV2>
      </Box>
      <CreditCardToggle
        formik={formik}
        canEnableCreditCard={canEnableCreditCard}
      />
      <AppPlatformToggle {...props} />
      <CashOrCheckToggle formik={formik} />
      {formik.errors.enableAppPlatform || formik.errors.enableCashOrCheck || formik.errors.enableJoyCredit ? (
        <TextV2
          marginBottom={2}
          textAlign="center"
          typographyVariant="label1"
          color="red"
        >
          {errorValidation}
        </TextV2>
      ) : null}
    </Flex>
  );
};
